import { toast } from 'react-toastify'
import * as ActionTypes from './ActionTypes'
import { apiRequest } from '../functions/apiRequest';

const userID = parseInt(localStorage.getItem("userID"));

export const fetchUser = (token, userID) => {
  return async function (dispatch) {
    const response = await apiRequest('get', null, `/user/profile/${userID}`, token, null, {}, true);
    dispatch({ type: ActionTypes.GET_USER, payload: response.data });
  }
}

export const fetchGuest = (token, userID) => {
  return async function (dispatch) {
    const response = await apiRequest('get', null, `/user/profile/${userID}`, token, null, {}, true);
    dispatch({ type: ActionTypes.GET_GUEST, payload: response.data });
  }
}

export const updateUser = (token, userID, body) => {
  return async function (dispatch) {
    await apiRequest('PUT', JSON.stringify(body), `/user/update/${userID}`, token, null, {}, true);
    toast.success('Profile successfully updated')
    // dispatch({ type: ActionTypes.UPDATE_USER, payload: response.data })
  }
}

export const updateActivity = (token, id, body) => {
  return async function (dispatch) {
    const response = await apiRequest('PUT', JSON.stringify(body), `/detail/${id}`, token, null, {}, true);
    toast.warning('Updating.....');
    dispatch({ type: ActionTypes.UPDATE_POST, payload: response.data });
    setTimeout(() => {
      window.location.href = `/event/${id}`;
    }, 2000)
  }
}

export const getActivity = (token) => {
  return async function (dispatch) {
    const response = await apiRequest('GET', null, `/display/all`, token, null, { 'Accept': 'application/json' }, true);
    dispatch({ type: ActionTypes.GET_POST, payload: response.data })
  }
}

export const singleActivity = (token, id) => {
  return async function (dispatch) {
    const response = await apiRequest('GET', null, `/detail/${id}`, token, null, {}, true);
    dispatch({ type: ActionTypes.SINGLE_POST, payload: response.data })
  }
}

export const addActivity = (token, body, setAct, body2, pid = 0, setBtn) => {
  return async function (dispatch) {
    const response = await apiRequest('POST', JSON.stringify(body), `/create/?program_id=${pid}`, token, null, { 'Accept': 'application/json' }, true);
    const { data } = response;
    // if (body['service_type'] === 'O' || body['act_status'] === true || userID === 1) {
    //   if (userID === parseInt(data['founder']) || body['act_status'] === true) {
        const creditResponse = await apiRequest('PUT', JSON.stringify({ creds: `${body2.creds}` }), `/act/credit/${data['id']}`, token, null, {}, true);
        const creditData = creditResponse.data;
        if (creditData['success'] === 'Updated Successfully') {
          toast.success('Time Cred$ sent');
          toast.success('Your event is live!')
          setTimeout(() => window.location.href = `/event/${data['id']}`, 1000)
        } else {
          toast.error('Credit Balance insufficient');
        }
    // } else {
    //   body2['program'] = data['id']
    //   body2['program_name'] = data['title']
    //   toast.success('Your event has been created successfully')
    //   await apiRequest('POST', JSON.stringify([body2]), `/notif/send/${body2.founderID}`, token, null, {}, true);
    //   toast.success('Request sent')
    //   // Sending notification to the admin on event creation (based on discussion on 29 - mar - 2022)
    //   if (parseInt(body2.founderID) !== 1) {
    //     await apiRequest('POST', JSON.stringify([body2]), `/notif/send/1`, token, null, {}, true);
    //   }
    // }
          
    //     }
    dispatch({ type: ActionTypes.ADD_POST, payload: response.data })
    setAct(data)
    setTimeout(() => window.location.href = `/program/${pid}`, 1500)
    setBtn(true);
  }
}

export const loginUser = (body) => {
  return async function (dispatch) {
    const response = await apiRequest('POST', JSON.stringify(body), `/user/login/`, null, null, {}, true);
    const data = response.data;
    if (data) {
      const token = data['token']
      const id = data['id']
      const fn = data['first_name']
      const email_id = data['email_id']
      if (token) {
        localStorage.setItem('token', token)
        localStorage.setItem('userID', id)
        localStorage.setItem('first_name', fn)
        localStorage.setItem('email_id', email_id)
        localStorage.setItem('parent_id', id)
        localStorage.setItem('parent_token', token)
        const userDetails = { first_name: data['first_name'], last_name: data['last_name'], profile_pic: data['profile_pic'], created_at: data['created_at'] };
        localStorage.setItem('user', JSON.stringify(userDetails));
        dispatch({ type: ActionTypes.LOGIN_USER, payload: response.data })
        window.location.href = '/profiles/choose'
      } else {
        toast.warning('Incorrect username or password')
      }
    } else {
      toast.warning('Incorrect username or password')
    }
  }
}

export const registerUser = (body, setisLoading) => {
  return async function (dispatch) {
    const response = await apiRequest('POST', JSON.stringify(body), `/user/register/`, null, null, {}, true);
    const data = response.data;
    if (data['status'] === 400) {
      toast.warning(data.errors);
    } else if (!data.id) {
      setisLoading(false);
      toast.warning('Please Try Again');
      return;
    } else if (data.id) {
      window.location.href = '/email'
    }
    setisLoading(false);
  }
}

export const sendNotif = (token, body, to_user) => {
  return async function (dispatch) {
    const response = await apiRequest('POST', JSON.stringify(body), `/notif/send/${to_user}`, token, null, {}, true);
    toast.success('Request sent!')
    dispatch({ type: ActionTypes.ADD_NOTIF, payload: response.data })
  }
}

